import React, { useEffect, useState, useContext } from 'react';
import AboutUs from '../AboutUs/AboutUs';
import Categories from '../Categories/Categories';
import Contact from '../Contact/Contact';
import Gallery from '../Gallery/Gallery';
import Navbar from '../Navbar/Navbar';
import SlideShow from '../SlideShow/SlideShow';
import Testimonial from '../Testimonial/Testimonial';
import ScrollToTop from "react-scroll-to-top";
import Footer from '../Footer/Footer';
import categoriesData from '../../fakeData/categoriesData';
import { collectionContext } from '../../App';
import { useSlideShowDataQuery } from '../../features/api/apiSlice';
import { Zoom } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import img1 from '../../images/Slide-show/slide_img_1.png';
import img2 from '../../images/Slide-show/slide_img_2.png';
import img3 from '../../images/Slide-show/slide_img_2.png';
const images = [
    img1,
    img2,
    'https://image1.jdomni.in/banner/21122020/EF/5B/DD/3CD7295AC6D48DD119CFE86799_1608544747771.jpg?output-format=webp',
    img3
];
const Home = ({ refresh }) => {

    const [slideShowData, setSlideShowData] = useState([]);
    const { value5 } = useContext(collectionContext);
    const { data: slideShow } = useSlideShowDataQuery();

    const [, setPage] = value5;
    useEffect(() => {
        setPage(1);
        setSlideShowData(slideShow);
    }, [slideShow, setPage])

    return (
        <>
            <ScrollToTop smooth />
            <Navbar refresh={refresh} />
            <Zoom scale={0.7} indicators={true}>
                {images.map((each, index) => (
                    <div key={index} style={{ width: "100%" }}>
                        <img style={{ objectFit: "cover", width: "100%" }} alt="" src={each} />
                    </div>
                ))}
            </Zoom>
            <Categories title={'Categories'} categoriesData={categoriesData} />
            <SlideShow slideShowData={slideShowData} />
            <AboutUs />
            <Gallery />
            <Testimonial />
            <Contact />
            <Footer />
        </>
    );
};

export default Home;